import { SVGProps } from 'react';

export function AffiliationIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M8.19995 1H11.8V4.6H8.19995V1Z"
        stroke="currentcolor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.19995 15.3999H11.8V18.9999H8.19995V15.3999Z"
        stroke="currentcolor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.3999 8.19995H18.9999V11.8H15.3999V8.19995Z"
        stroke="currentcolor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1 8.19995H4.6V11.8H1V8.19995Z"
        stroke="currentcolor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.0271 8.1999C3.34953 6.95466 3.99922 5.81834 4.90878 4.90878C5.81834 3.99922 6.95466 3.34953 8.1999 3.0271"
        stroke="currentcolor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.1951 16.9719C6.95111 16.6488 5.81607 15.9991 4.90745 15.09C3.99884 14.181 3.34966 13.0457 3.0271 11.8015"
        stroke="currentcolor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.9728 11.8008C16.6501 13.0458 16.0003 14.1819 15.0908 15.0913C14.1813 16.0006 13.0451 16.6503 11.8 16.9728"
        stroke="currentcolor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.8103 3.02954C13.0532 3.35341 14.187 4.00335 15.0946 4.9122C16.0022 5.82104 16.6506 6.95579 16.9727 8.19914"
        stroke="currentcolor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
